var _g, _path, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0Z",
    fill: "black",
    fillOpacity: 0.01
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7862 19.7638H12.7359C12.5821 19.7638 12.4573 19.6386 12.4573 19.4843V16.1301C12.4573 15.9758 12.5821 15.8506 12.7359 15.8506H16.3863C16.944 15.4984 17.6014 15.2916 18.3073 15.2916C18.6549 15.2916 19.0031 15.343 19.3419 15.4442C19.4266 15.4705 19.5174 15.4531 19.5876 15.4006C19.626 15.3721 19.6556 15.3341 19.6751 15.2916H21.098C21.2607 15.2882 21.3827 15.1686 21.3821 15.0121C21.3821 14.9109 21.3286 14.8226 21.2484 14.7734L19.6996 13.2193V8.86277C19.6996 8.70847 19.5748 8.58325 19.421 8.58325H17.1925C17.0387 8.58325 16.9139 8.70847 16.9139 8.86277V10.4241L15.3578 8.86277C14.9996 8.50275 14.3728 8.50219 14.0134 8.86277L8.08159 14.8142C8.00192 14.8941 7.97796 15.0143 8.02142 15.1188C8.06432 15.2234 8.16627 15.2916 8.27882 15.2916H9.67166V21.7204C9.67166 21.8747 9.79646 21.9999 9.95023 21.9999H15.5801C15.6932 21.9999 15.7952 21.9312 15.8381 21.8261C15.881 21.721 15.8559 21.6002 15.7751 21.5208C15.2776 21.0317 14.9416 20.4246 14.7862 19.7638ZM18.3524 15.8506C16.6626 15.8506 15.2882 17.2297 15.2882 18.9252C15.2882 20.6208 16.6626 21.9999 18.3524 21.9999C20.0422 21.9999 21.4167 20.6208 21.4167 18.9252C21.4167 17.2297 20.0422 15.8506 18.3524 15.8506ZM18.631 19.2047H19.4667C19.621 19.2047 19.7453 19.0795 19.7453 18.9252C19.7453 18.7709 19.6205 18.6457 19.4667 18.6457H18.631V17.8072C18.631 17.6529 18.5062 17.5277 18.3524 17.5277C18.1986 17.5277 18.0738 17.6529 18.0738 17.8072V18.6457H17.2381C17.0844 18.6457 16.9596 18.7709 16.9596 18.9252C16.9596 19.0795 17.0844 19.2047 17.2381 19.2047H18.0738V20.0433C18.0738 20.1976 18.1986 20.3228 18.3524 20.3228C18.5062 20.3228 18.631 20.1976 18.631 20.0433V19.2047Z",
    fill: "#2E3758"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_1",
    x: -27.1828,
    y: -27.1828,
    width: 84.3656,
    height: 84.3656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 13.5914
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.823085cfe653c1d0d61abc8735caa146.svg";
export { ForwardRef as ReactComponent };